<template lang="">
    <div id="header">
        <div class="inner clearfix">
            <div class="fll clearfix">
                <h1 class="site_logo">
                    <a href="/" title="ホーム" rel="home" id="logo">
                        <!-- src="/themes/custom/agrknldgtheme/common/images/site_lgo.png" -->
                        <img src="/images/site_lgo.png" alt="ホーム" />
                    </a>
                </h1>
                <p class="site_lead">
                    農林水産研究に関する国内の論文・情報が探せる<br />データベース(アグリナレッジ)
                </p>
                <p class="site_lead">
                    A database providing information on agricultural<br />
                    science and technology of Japan.
                </p>
            </div>
            <div id="navigation">
                <div class="header_menu">
                    <div class="utility_menu clearfix">
                        <div class="font_size">
                            <ul class="clearfix">
                                <li>
                                    <a
                                        href="javascript:void(0);"
                                        id="normal_font_button"
                                        v-on:click="setNormal"
                                        >標準</a
                                    >
                                </li>
                                <li>
                                    <a
                                        href="javascript:void(0);"
                                        id="bigger_font_button"
                                        v-on:click="setBigger"
                                        >拡大</a
                                    >
                                </li>
                            </ul>
                            <p>文字サイズ</p>
                        </div>
                        <!-- /.font_size -->
                    </div>
                    <!--/.utility_menu clearfix -->

                    <ul class="header_link clearfix">
                        <li>
                            <a
                                target="_blank"
                                href="https://www.agropedia.affrc.go.jp/inquiry"
                                >お問い合わせ</a
                            >
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.agropedia.affrc.go.jp/agriknowledge/api"
                            >
                                WebAPI
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                href="https://www.agropedia.affrc.go.jp/agriknowledge"
                                >AgriKnowledgeとは</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /.header_menu, /#navigation -->
        </div>
        <!-- /.inner -->
    </div>
    <!-- /#header -->
</template>

<script>
export default {
    name: "AppHeader",
    setup() {
        const setBigger = (e) => {
            let app_div = e.currentTarget.closest("#app");
            app_div.className = "bigger-font";
        };
        const setNormal = (e) => {
            let app_div = e.currentTarget.closest("#app");
            app_div.className = "";
        };
        return {
            setNormal,
            setBigger,
        };
    },
};
</script>

<style>
/*----------------------------------------
    header
----------------------------------------*/
.panels-flexible-region-agriknowledge_site-form,
.panels-flexible-region-agriknowledge_site-bottm_bnr {
    width: 100%;
}
.panel-flexible .panel-separator {
    margin: 0;
}
/*search.css*/
.hide {
    display: none;
}
.alert {
    font-size: 120%;
    padding: 0 10px 30px 10px;
}

/*************/
body.all h1.page_ttl,
body.paper h1.page_ttl,
body.product h1.page_ttl,
body.seika h1.page_ttl,
body.kadai h1.page_ttl,
body.gyouseki h1.page_ttl,
body.hinshu h1.page_ttl,
body.image h1.page_ttl,
body.noukigu h1.page_ttl {
    display: none;
}
label {
    display: inline;
    font-weight: bold;
}
#header {
    border-top: 5px solid #188031;
}
#header > .inner {
    width: 980px;
    margin: 0 auto;
    position: relative;
}
#header .skip_link {
    position: absolute;
    top: -5px;
    left: 0;
}
#header .skip_link a {
    text-decoration: underline;
    border: 1px solid #188031;
    display: block;
    border-radius: 0 0 4px 4px;
    padding: 9px 17px 4px;
    background-color: #fff;
    border-top: none;
    font-size: 107.14%;
    line-height: 1;
}
#header .fll {
    float: left;
    margin: 10px 0;
    /*max-width: 610px;*/
    max-width: 580px;
    overflow: hidden;
}
#header .header_menu {
    float: right;
    /*width: 365px;*/
    width: 400px;
}
#header .site_logo {
    float: left;
    width: 243px;
    padding-top: 15px;
}
#header .site_lead {
    color: #535353;
    float: left;
    font-size: 85.71%;
    line-height: 1.4;
    margin: 10px 0 0 20px;
}
#header .site_lead + .site_lead {
    font-size: 88%; /*92.85%;*/
    margin: 2px 0 0 20px;
}
.bigger-font #header .site_lead + .site_lead {
    font-size: 74.6%;
    margin: 2px 0 0 20px;
}

/* font_size */
#header .font_size {
    float: left;
    margin-top: 10px;
    /*	margin-left: 35px;*/
    width: 100%;
}
#header .font_size > p {
    float: right;
    margin-right: 7px;
    font-size: 92.85%;
    text-align: right !important;
}
#header .font_size > ul {
    /*float: left;*/
    float: right !important;
}
#header .font_size li {
    float: left;
    font-size: 107.14%;
    line-height: 1.6;
}
#header .font_size li a {
    color: #fff;
    display: block;
    text-align: center;
    width: 80px;
}
#header .font_size li a:hover {
    text-decoration: none;
    opacity: 0.8;
}
#normal_font_button {
    background-color: #008000;
    cursor: default;
    margin-right: 3px;
    border-radius: 15px 0 0 15px;
}
.bigger-font #normal_font_button {
    cursor: pointer;
    background-color: #999999;
}
#bigger_font_button {
    cursor: pointer;
    background-color: #999999;
    border-radius: 0 15px 15px 0;
}
.bigger-font #bigger_font_button {
    cursor: default;
    background-color: #008000;
}

/* lang_menu */
#header .lang_menu {
    float: right;
    width: 110px;
}
#header .lang_menu a {
    display: block;
    color: #fff;
    text-align: center;
    text-decoration: underline;
    background-color: #188031;
    border-radius: 0 0 8px 8px;
    padding: 5px 0;
    transition: 0.3s;
}
#header .lang_menu a:hover {
    background-color: #6b9c38;
}

/* header_link */
#header .header_link {
    margin: 17px 0;
}
.bigger-font #header .header_link {
    font-size: 92%;
}
#header .header_link li {
    float: right;
}
#header .header_link li + li {
    margin-right: 20px;
}
#header .header_link a {
    display: block;
    padding-left: 19px;
    text-decoration: underline;
    /* background: url(../images/icon_leaf.jpg) no-repeat 0 8px; */
    background: url("../../public/images/icon_leaf.jpg") no-repeat 0 8px;
}
.bigger-font {
    font-size: 118%;
    --el-font-size-base: 118%;
}
.bigger-font .el-breadcrumb__item {
    font-size: 118%;
}
.bigger-font .search_link {
    font-size: 118%;
}
.bigger-font span.el-checkbox__label > strong,
.bigger-font span.el-checkbox__label span {
    font-size: 16.5px;
}
.bigger-font .el-form-item__content .el-checkbox {
    min-height: 50px;
}
.bigger-font .el-form-item__error {
    font-size: 118%;
}
.bigger-font .el-pagination {
    --el-pagination-font-size: 15.3px;
}
</style>
